import { watchProgressThrottleMs } from "../../../lib/videoStateTypes";

type EnqueueFn = (videoId: string) => void;

export class WatchProgressThrottle {
  private lastEnqueueMs = new Map<string, number>();

  constructor(
    private readonly enqueue: EnqueueFn,
    private readonly intervalMs: number = watchProgressThrottleMs,
  ) {}

  notify(videoId: string, nowMs: number = Date.now()): void {
    const last = this.lastEnqueueMs.get(videoId);

    if (last != null && nowMs - last < this.intervalMs) {
      return;
    }

    this.lastEnqueueMs.set(videoId, nowMs);
    this.enqueue(videoId);
  }

  flushNow(videoId: string, nowMs: number = Date.now()): void {
    this.lastEnqueueMs.set(videoId, nowMs);
    this.enqueue(videoId);
  }
}
